module.exports = __webpack_public_path__ + "img/placard_m_04.56bade60.png";